var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editable) ? _c('div', [(_vm.multi) ? _c('div', [_c('Upload', {
    ref: "uploader",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "data": _vm.uploadConfig,
      "accept": _vm.accept,
      "max-size": _vm.maxsize,
      "show-upload-list": false,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.imageUploadSuccess,
      "on-progress": _vm.imageProgress,
      "multiple": "",
      "action": "//upload.qiniup.com/"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.result), function(image, index) {
    return _c('div', {
      key: index
    }, [_c('Poptip', {
      attrs: {
        "trigger": "hover",
        "transfer": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "margin-right": "16px",
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.toView(index)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "margin-right": "16px",
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(index)
        }
      }
    }, [_vm._v("前移")]), _vm._v(" "), _c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "margin-right": "16px",
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(index)
        }
      }
    }, [_vm._v("后移")]), _vm._v(" "), _c('a', {
      staticClass: "hoverbtn",
      staticStyle: {
        "color": "tomato"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), (_vm.type == 'image') ? _c('img', {
      staticClass: "hover image",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "4px",
        "display": "block"
      },
      attrs: {
        "src": image.url + '?imageView2/1/w/100/h/100'
      },
      on: {
        "click": function($event) {
          return _vm.toUpload(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type == 'video') ? _c('img', {
      staticClass: "hover image",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "4px",
        "display": "block"
      },
      attrs: {
        "src": image.url + '?vframe/jpg/offset/1'
      },
      on: {
        "click": function($event) {
          return _vm.toUpload(index)
        }
      }
    }) : _vm._e()])], 1)
  }), _vm._v(" "), (!_vm.max || _vm.result.length < _vm.max) ? _c('Button', {
    staticClass: "image",
    staticStyle: {
      "height": "32px",
      "width": "32px",
      "border-radius": "4px",
      "border": "1px dashed #ddd",
      "color": "#20bf64",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-add",
      "size": "32"
    }
  })], 1) : _vm._e()], 2)])], 1) : _c('div', [_c('Upload', {
    ref: "uploader",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "data": _vm.uploadConfig,
      "accept": _vm.accept,
      "max-size": _vm.maxsize,
      "show-upload-list": false,
      "on-success": _vm.imageUploadSuccess,
      "on-progress": _vm.imageProgress,
      "multiple": "",
      "action": "//upload.qiniup.com/"
    }
  }, [(_vm.result) ? _c('div', [_c('Poptip', {
    attrs: {
      "trigger": "hover",
      "transfer": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('a', {
    staticClass: "hoverbtn",
    staticStyle: {
      "color": "tomato"
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_vm._v("删除")])]), _vm._v(" "), (_vm.type == 'image') ? _c('img', {
    staticClass: "hover",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result.url + '?imageView2/1/w/100/h/100'
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'video') ? _c('img', {
    staticClass: "hover",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result.url + '?vframe/jpg/offset/1'
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }) : _vm._e()])], 1) : _c('Button', {
    staticStyle: {
      "height": "32px",
      "width": "32px",
      "border-radius": "4px",
      "border": "1px dashed #ddd",
      "color": "#20bf64",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.toUpload()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-add",
      "size": "32"
    }
  })], 1)], 1)], 1)]) : _c('div', [(_vm.multi) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.result), function(image, index) {
    return _c('img', {
      key: index,
      staticClass: "image",
      staticStyle: {
        "width": "32px",
        "height": "32px",
        "border-radius": "4px",
        "display": "block"
      },
      attrs: {
        "src": image.url + '?imageView2/1/w/100/h/100'
      },
      on: {
        "click": function($event) {
          return _vm.openImage(image.url)
        }
      }
    })
  }), 0) : _c('div', [(_vm.result.type == 'image') ? _c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result ? (_vm.result.url + '?imageView2/1/w/100/h/100') : ''
    },
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.result ? _vm.result.url : '')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.result.type == 'video') ? _c('img', {
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "display": "block",
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.result ? (_vm.result.url + '?vframe/jpg/offset/1') : ''
    },
    on: {
      "click": function($event) {
        return _vm.openImage(_vm.result ? _vm.result.url : '')
      }
    }
  }) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44de5bd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Uploader.vue
// module id = Bvx/
// module chunks = 138